import { render, staticRenderFns } from "./ApplicationValues.vue?vue&type=template&id=70b3b38a&scoped=true&lang=html&"
import script from "./ApplicationValues.vue?vue&type=script&lang=js&"
export * from "./ApplicationValues.vue?vue&type=script&lang=js&"
import style0 from "./ApplicationValues.vue?vue&type=style&index=0&id=70b3b38a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b3b38a",
  null
  
)

export default component.exports